import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { sendSpaPageView } from "helpers/ga4Ecommerce";

/**
 * Layout root router: SPA tidak reload, page_view GA4 dikirim manual tiap perubahan route.
 */
export default function AnalyticsLayout() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    sendSpaPageView(path);
  }, [location.pathname, location.search]);

  return <Outlet />;
}
